export enum ResponseServiceConfigurationError {
  NOT_IN_TRIAL_ERROR = "response_service_not_in_trial_error",
  MISSING_PHONE_NUMBER_ERROR = "response_service_missing_phone_number_error",
  NO_ADDRESS_ERROR = "response_service_no_address_error",
  NOT_AVAILABLE_AT_LOCATION = "response_service_not_available_at_location",
  NO_LOCATION_SET = "response_service_no_location_set",
}
